import type { CategoryItem, NewsItem } from "@/types/news";

export const categories: CategoryItem[] = [
  {
    key: "entertainment",
    name: "娱乐",
    description: "聚焦综艺、影视与明星动态，第一时间捕捉娱乐圈的热点与幕后故事。",
    subCategories: ["全部", "综艺", "影视", "明星"],
  },
  {
    key: "politics",
    name: "时政",
    description: "关注政策发布与民生动向，解读与普通人息息相关的时政要闻。",
    subCategories: ["全部", "政策", "民生", "国际"],
  },
  {
    key: "tech",
    name: "科技",
    description: "追踪人工智能、数码与新能源前沿，用通俗视角讲清科技新趋势。",
    subCategories: ["全部", "AI", "数码", "汽车"],
  },
  {
    key: "society",
    name: "社会",
    description: "记录城市与社区的鲜活现场，关注天气、民生与凡人善举。",
    subCategories: ["全部", "天气", "人物", "民生"],
  },
  {
    key: "finance",
    name: "财经",
    description: "解读股市、消费与产业变化，为关注钱袋子的你提供清晰脉络。",
    subCategories: ["全部", "股市", "消费", "产业"],
  },
  {
    key: "sports",
    name: "体育",
    description: "直击赛场内外，从足球到综合赛事，捕捉每一场热血与荣耀。",
    subCategories: ["全部", "足球", "篮球", "综合"],
  },
];

export const newsList: NewsItem[] = [
  {
    id: "1001",
    title: "顶流男星深夜现身录音棚，疑似筹备全新专辑",
    subtitle: "连续三晚被拍，经纪人未否认「正在打磨作品」",
    summary:
      "有网友连续三晚在同一间录音棚外偶遇这位顶流男星，现场还出现了多位知名音乐制作人，新专辑传闻迅速登上热搜。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20recording%20studio%20interior%20with%20mixing%20console%20and%20warm%20ambient%20lighting%2C%20microphone%20in%20focus%2C%20moody%20cinematic%20atmosphere%2C%20editorial%20music%20production%20photography%2C%20shallow%20depth%20of%20field%2C%20deep%20blue%20and%20orange%20tones&width=800&height=500&seq=news-cover-91-01&orientation=landscape",
    category: "娱乐",
    subCategory: "明星",
    author: "91爆料娱乐组",
    publishDate: "2026-10-16 09:20",
    views: 128600,
    likes: 8420,
    tags: ["明星", "音乐", "热搜"],
    featured: true,
    hot: true,
    content: [
      { type: "p", text: "昨夜十一点，本报记者在城南一处知名录音棚外看到，一位近期话题度极高的顶流男星低调抵达现场。与他同行的还有两位业内知名的音乐制作人，整个团队一直工作到凌晨两点才离开。" },
      { type: "h2", text: "连续三晚现身，行程高度保密" },
      { type: "p", text: "据现场工作人员透露，这已经是该男星连续第三晚出现在这间录音棚。与平日高调的公开活动不同，此次行程没有对外宣传，团队也刻意避开了正门口，选择从侧门进出。" },
      { type: "quote", text: "「他这次是真的想沉下心做音乐，很多细节都亲自盯。」——一位不愿具名的业内人士表示。" },
      { type: "p", text: "面对媒体询问，其经纪人并未否认相关传闻，只回应称艺人「一直在打磨新的作品，希望大家耐心等待」。截至发稿，相关话题阅读量已突破三亿。" },
    ],
  },
  {
    id: "1002",
    title: "年度爆款综艺收官，收视率刷新平台历史纪录",
    summary:
      "这档以普通人故事为主线的综艺节目昨晚迎来收官，实时收视峰值刷新平台纪录，多位嘉宾发文告别引发集体回忆。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20grand%20television%20variety%20show%20stage%20with%20vivid%20colorful%20stage%20lighting%2C%20spotlights%20and%20screens%2C%20glamorous%20production%20design%2C%20wide%20angle%20editorial%20entertainment%20photography%2C%20dramatic%20atmosphere&width=800&height=500&seq=news-cover-91-02&orientation=landscape",
    category: "娱乐",
    subCategory: "综艺",
    author: "91爆料娱乐组",
    publishDate: "2026-10-15 22:10",
    views: 96500,
    likes: 6120,
    tags: ["综艺", "收视"],
    hot: true,
    content: [
      { type: "p", text: "昨晚，备受关注的年度综艺正式收官。节目以普通人的真实故事为主线，凭借真诚的表达赢得大量观众共鸣，收官夜实时收视峰值刷新了平台历史纪录。" },
      { type: "h2", text: "真诚叙事成为最大亮点" },
      { type: "p", text: "与依赖强冲突的综艺不同，这档节目把镜头更多留给了平凡人。多位观众表示，正是这些不加修饰的细节，让人看到了生活的温度。" },
      { type: "p", text: "节目结束后，多位嘉宾在社交平台发文告别，相关话题迅速占领热搜榜前列。平台方表示，后续或将推出特别篇回馈观众。" },
    ],
  },
  {
    id: "1003",
    title: "悬疑剧《暗流》口碑逆袭，剧情反转引发全民猜想",
    summary:
      "开播时并不被看好的悬疑剧《暗流》，凭借扎实的剧本和层层反转，评分一路走高，成为近期讨论度最高的剧集之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20still%20inspired%20by%20a%20suspense%20thriller%2C%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%2C%20mysterious%20fog%2C%20film%20noir%20editorial%20photography%2C%20deep%20shadows&width=800&height=500&seq=news-cover-91-03&orientation=landscape",
    category: "娱乐",
    subCategory: "影视",
    author: "91爆料娱乐组",
    publishDate: "2026-10-14 18:40",
    views: 78200,
    likes: 5340,
    tags: ["影视", "悬疑"],
    content: [
      { type: "p", text: "《暗流》在开播之初并未引起太多关注，但随着剧情推进，扎实的剧本与密集的反转逐渐吸引了大批观众，评分从最初的及格线一路上扬。" },
      { type: "h2", text: "剧本扎实，反转不靠噱头" },
      { type: "p", text: "不少观众认为，该剧的反转并非为了制造意外而强行设计，而是建立在前期大量铺垫之上，回看时处处可见伏笔。" },
      { type: "p", text: "目前该剧已进入收官阶段，围绕最终真相的讨论仍在持续，相关话题多次登上热搜。" },
    ],
  },
  {
    id: "1004",
    title: "新一轮民生改革政策发布，惠及千万家庭",
    summary:
      "相关部门今日发布新一轮民生改革举措，覆盖教育、医疗与住房等多个领域，预计将惠及千万家庭。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20city%20government%20building%20with%20clean%20architectural%20lines%20at%20golden%20hour%2C%20people%20walking%20on%20plaza%2C%20bright%20optimistic%20atmosphere%2C%20editorial%20news%20photography%2C%20warm%20light&width=800&height=500&seq=news-cover-91-04&orientation=landscape",
    category: "时政",
    subCategory: "政策",
    author: "91爆料时政组",
    publishDate: "2026-10-16 08:05",
    views: 112400,
    likes: 4980,
    tags: ["政策", "民生"],
    featured: true,
    hot: true,
    content: [
      { type: "p", text: "今日上午，相关部门正式发布新一轮民生改革举措。此次政策覆盖面广、力度大，重点聚焦群众关切的教育、医疗和住房等现实问题。" },
      { type: "h2", text: "教育医疗住房三大领域同步发力" },
      { type: "p", text: "在医疗领域，新政提出进一步优化基层就诊流程，推动优质医疗资源下沉；在教育领域，则强调继续扩大普惠性资源供给。" },
      { type: "quote", text: "「政策的落脚点，就是让老百姓的日子更方便、更踏实。」——发布会现场一位负责人表示。" },
      { type: "p", text: "业内人士分析，此次改革有望在多个层面释放长期利好，具体实施细则将陆续公布。" },
    ],
  },
  {
    id: "1005",
    title: "城市更新行动全面启动，老旧小区迎来改造利好",
    summary:
      "多地城市更新行动同步启动，老旧小区改造、口袋公园建设等一批民生工程集中开工，居民生活品质有望明显提升。",
    cover:
      "https://readdy.ai/api/search-image?query=Renovated%20residential%20community%20with%20new%20playground%20and%20green%20landscaping%2C%20sunny%20afternoon%2C%20clean%20urban%20renewal%20project%2C%20editorial%20documentary%20photography%2C%20harmonious%20composition&width=800&height=500&seq=news-cover-91-05&orientation=landscape",
    category: "时政",
    subCategory: "民生",
    author: "91爆料时政组",
    publishDate: "2026-10-13 16:20",
    views: 64300,
    likes: 3120,
    tags: ["民生", "城市"],
    content: [
      { type: "p", text: "随着城市更新行动全面启动，多个老旧小区改造项目近日集中开工。外墙翻新、管网更新、加装电梯等居民关心的改造内容被列入首批清单。" },
      { type: "h2", text: "从「住有所居」到「住有宜居」" },
      { type: "p", text: "此次改造不再停留于表面翻新，而是同步补齐停车、托育、养老等公共服务短板。部分社区还将利用边角空间建设口袋公园。" },
      { type: "p", text: "不少居民表示，改造后的小区环境焕然一新，生活便利度明显提高。" },
    ],
  },
  {
    id: "1006",
    title: "国产大模型迎来重大突破，推理能力比肩国际顶尖",
    summary:
      "国内团队发布新一代大模型，在多项推理与代码能力评测中取得领先成绩，标志着国产人工智能迈上新台阶。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20glowing%20neural%20network%20visualization%20over%20dark%20background%2C%20intricate%20data%20streams%20and%20nodes%2C%20futuristic%20artificial%20intelligence%20concept%2C%20cool%20blue%20and%20orange%20highlights%2C%20editorial%20technology%20illustration&width=800&height=500&seq=news-cover-91-06&orientation=landscape",
    category: "科技",
    subCategory: "AI",
    author: "91爆料科技组",
    publishDate: "2026-10-16 10:30",
    views: 158900,
    likes: 11240,
    tags: ["AI", "大模型"],
    featured: true,
    hot: true,
    content: [
      { type: "p", text: "今日，国内研究团队正式发布新一代大模型。在多项公开评测中，该模型在逻辑推理、数学求解和代码生成等任务上取得领先成绩，多项指标比肩国际顶尖水平。" },
      { type: "h2", text: "推理能力成为核心突破点" },
      { type: "p", text: "与前代相比，新模型最显著的变化在于推理能力的提升。团队介绍，他们在训练方法和数据构建上做了大量优化，使模型能够更稳定地完成多步骤复杂任务。" },
      { type: "quote", text: "「我们更在意的是，模型能不能真的帮人把问题解决掉。」——项目负责人表示。" },
      { type: "p", text: "目前该模型已面向部分开发者开放测试，后续将逐步扩大开放范围。" },
    ],
  },
  {
    id: "1007",
    title: "折叠屏手机销量暴涨，供应链透露下一代形态",
    summary:
      "最新数据显示折叠屏手机销量同比增长明显，供应链人士透露，更轻薄、更耐用的新一代方案已在路上。",
    cover:
      "https://readdy.ai/api/search-image?query=Sleek%20modern%20foldable%20smartphone%20on%20minimalist%20desk%20surface%20with%20soft%20studio%20lighting%2C%20premium%20product%20photography%2C%20clean%20neutral%20background%2C%20crisp%20shadows%20and%20reflections&width=800&height=500&seq=news-cover-91-07&orientation=landscape",
    category: "科技",
    subCategory: "数码",
    author: "91爆料科技组",
    publishDate: "2026-10-12 14:00",
    views: 71200,
    likes: 4230,
    tags: ["数码", "手机"],
    content: [
      { type: "p", text: "最新市场数据显示，折叠屏手机销量同比实现大幅增长，正从尝鲜产品走向更多用户的日常选择，价格下探和体验改善是主要推动力。" },
      { type: "h2", text: "轻薄与耐用成为竞争焦点" },
      { type: "p", text: "供应链人士透露，多家厂商正在推进更轻薄、折痕更浅的新一代方案，新的铰链结构和屏幕材料有望在明年量产。" },
      { type: "p", text: "分析认为，随着成本进一步下降，折叠屏有望在高端市场占据更大份额。" },
    ],
  },
  {
    id: "1008",
    title: "新能源汽车渗透率再创新高，充电网络加速铺设",
    summary:
      "新能源汽车市场渗透率持续攀升，多地加快充电基础设施建设，节假日高速充电排队问题有望缓解。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20electric%20vehicle%20charging%20station%20on%20a%20clean%20urban%20street%2C%20futuristic%20car%20silhouette%2C%20bright%20daylight%2C%20sustainable%20energy%20concept%2C%20editorial%20automotive%20photography&width=800&height=500&seq=news-cover-91-08&orientation=landscape",
    category: "科技",
    subCategory: "汽车",
    author: "91爆料科技组",
    publishDate: "2026-10-11 09:15",
    views: 58900,
    likes: 3010,
    tags: ["汽车", "新能源"],
    content: [
      { type: "p", text: "行业数据显示，新能源汽车市场渗透率再次刷新纪录，越来越多的家庭在换购时优先考虑电动化车型。" },
      { type: "h2", text: "充电焦虑正在被逐步化解" },
      { type: "p", text: "为配套市场增长，多地加快充电基础设施建设，高速服务区与城市公共停车场的大功率充电桩数量明显增加。" },
      { type: "p", text: "随着补能网络日益完善，消费者的里程焦虑有望进一步降低。" },
    ],
  },
  {
    id: "1009",
    title: "暴雨橙色预警发布，多地启动应急响应",
    summary:
      "气象部门发布暴雨橙色预警，多地迅速启动防汛应急响应，提醒公众减少外出、注意出行安全。",
    cover:
      "https://readdy.ai/api/search-image?query=Heavy%20rain%20over%20a%20modern%20city%20skyline%2C%20dark%20storm%20clouds%20and%20wet%20streets%2C%20dramatic%20weather%20atmosphere%2C%20moody%20editorial%20news%20photography%2C%20deep%20blue%20tones&width=800&height=500&seq=news-cover-91-09&orientation=landscape",
    category: "社会",
    subCategory: "天气",
    author: "91爆料社会组",
    publishDate: "2026-10-16 07:40",
    views: 143200,
    likes: 5640,
    tags: ["天气", "预警"],
    featured: true,
    hot: true,
    content: [
      { type: "p", text: "今日清晨，气象部门发布暴雨橙色预警，预计未来二十四小时内多地将出现强降雨天气。相关部门第一时间启动防汛应急响应。" },
      { type: "h2", text: "多部门联动保障城市运行" },
      { type: "p", text: "市政、交通、应急等多部门已进入值守状态，重点排查低洼路段与地下空间，并对部分易积水路段提前布设排水设备。" },
      { type: "quote", text: "「请市民尽量减少不必要的外出，遇到积水路段切勿贸然涉水。」——应急部门提醒。" },
      { type: "p", text: "气象部门表示，将持续跟踪雨情变化，及时更新预警信息。" },
    ],
  },
  {
    id: "1010",
    title: "外卖骑手深夜救人获表彰，平凡岗位上的英雄",
    summary:
      "一位外卖骑手在送餐途中发现落水者，毫不犹豫跳入水中施救，事迹传开后获得多方表彰。",
    cover:
      "https://readdy.ai/api/search-image?query=Delivery%20rider%20in%20city%20street%20at%20night%20with%20warm%20street%20lights%2C%20motion%20blur%2C%20urban%20scene%2C%20cinematic%20documentary%20photography%2C%20positive%20heroic%20mood&width=800&height=500&seq=news-cover-91-10&orientation=landscape",
    category: "社会",
    subCategory: "人物",
    author: "91爆料社会组",
    publishDate: "2026-10-10 20:50",
    views: 88700,
    likes: 9210,
    tags: ["人物", "正能量"],
    hot: true,
    content: [
      { type: "p", text: "上周深夜，一位外卖骑手在送餐途中听到呼救声，发现有人落水后，他立即停下电动车跳入水中将人救起，随后默默离开继续配送。" },
      { type: "h2", text: "救人之后，他赶着送完那一单" },
      { type: "p", text: "被救者家属几经周折才找到这位骑手。面对感谢，他只是朴素地说：「换了谁都会这么做。」" },
      { type: "p", text: "相关平台与社区随后对其进行了表彰，网友们纷纷留言：「平凡的岗位，也能有不平凡的担当。」" },
    ],
  },
  {
    id: "1011",
    title: "社区食堂火出圈，老年助餐服务如何可持续",
    summary:
      "一批社区食堂因物美价廉走红，老年助餐服务在方便居民的同时，也面临如何长效运营的现实课题。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20cozy%20community%20canteen%20with%20warm%20wooden%20tables%20and%20fresh%20healthy%20meals%2C%20elderly%20people%20dining%2C%20welcoming%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20warm%20tones&width=800&height=500&seq=news-cover-91-11&orientation=landscape",
    category: "社会",
    subCategory: "民生",
    author: "91爆料社会组",
    publishDate: "2026-10-09 11:30",
    views: 52100,
    likes: 2780,
    tags: ["民生", "社区"],
    content: [
      { type: "p", text: "近日，多个城市的社区食堂凭借实惠的价格和可口的饭菜走红网络，不仅方便了社区老人，也吸引了周边上班族前来就餐。" },
      { type: "h2", text: "方便背后，考验的是长效运营" },
      { type: "p", text: "社区食堂的公益属性较强，如何在低价格与可持续之间取得平衡，成为各方关注的焦点。部分街道尝试引入市场化运营与社会力量参与。" },
      { type: "p", text: "专家建议，通过稳定补贴、错峰经营和多元客群等方式，让助餐服务既能惠及老人，也能长久运转。" },
    ],
  },
  {
    id: "1012",
    title: "A股三大指数集体走高，科技板块领涨",
    summary:
      "今日A股三大指数集体上涨，科技板块表现强势，市场情绪回暖，成交额明显放大。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20financial%20stock%20market%20chart%20with%20rising%20candlesticks%20and%20data%20visualization%2C%20dark%20background%20with%20orange%20and%20blue%20accents%2C%20modern%20editorial%20finance%20illustration&width=800&height=500&seq=news-cover-91-12&orientation=landscape",
    category: "财经",
    subCategory: "股市",
    author: "91爆料财经组",
    publishDate: "2026-10-16 15:10",
    views: 92400,
    likes: 3860,
    tags: ["股市", "财经"],
    hot: true,
    content: [
      { type: "p", text: "今日A股三大指数集体走高，其中科技板块表现尤为突出，多只个股涨幅居前，市场成交额较前一日明显放大。" },
      { type: "h2", text: "资金关注度向科技主线集中" },
      { type: "p", text: "从盘面看，资金对科技方向关注度较高，半导体、人工智能相关概念持续活跃。机构观点认为，情绪回暖与产业预期改善共同推动市场走强。" },
      { type: "p", text: "分析人士同时提醒，市场波动仍存，投资者应保持理性，注意控制风险。" },
    ],
  },
  {
    id: "1013",
    title: "消费市场回暖明显，假日经济数据亮眼",
    summary:
      "最新数据显示假日期间消费市场明显回暖，餐饮、文旅与零售数据同步向好，线下人气持续回升。",
    cover:
      "https://readdy.ai/api/search-image?query=Busy%20modern%20shopping%20street%20with%20bright%20storefronts%20and%20shoppers%2C%20festive%20warm%20lighting%2C%20lively%20atmosphere%2C%20editorial%20retail%20photography%2C%20vibrant%20colors&width=800&height=500&seq=news-cover-91-13&orientation=landscape",
    category: "财经",
    subCategory: "消费",
    author: "91爆料财经组",
    publishDate: "2026-10-08 17:20",
    views: 61300,
    likes: 2540,
    tags: ["消费", "经济"],
    content: [
      { type: "p", text: "最新统计数据显示，假日期间消费市场明显回暖，餐饮、文旅、零售等多个领域数据同步向好，线下商圈人气持续回升。" },
      { type: "h2", text: "体验式消费成为新增长点" },
      { type: "p", text: "与以往相比，体验式、沉浸式消费受到更多青睐，特色市集、主题展览等新场景带动了周边消费。" },
      { type: "p", text: "业内预计，随着利好政策持续释放，消费市场有望保持稳中向好的态势。" },
    ],
  },
  {
    id: "1014",
    title: "国足热身赛惊险取胜，年轻球员挑大梁",
    summary:
      "在一场热身赛中，国足凭借终场前的进球惊险取胜，多名年轻球员获得出场机会并有不俗表现。",
    cover:
      "https://readdy.ai/api/search-image?query=Football%20stadium%20at%20night%20under%20bright%20floodlights%2C%20green%20pitch%20and%20empty%20stands%2C%20dramatic%20sports%20atmosphere%2C%20editorial%20sports%20photography%2C%20dynamic%20angle&width=800&height=500&seq=news-cover-91-14&orientation=landscape",
    category: "体育",
    subCategory: "足球",
    author: "91爆料体育组",
    publishDate: "2026-10-15 21:40",
    views: 105600,
    likes: 6890,
    tags: ["足球", "国足"],
    featured: true,
    hot: true,
    content: [
      { type: "p", text: "昨晚进行的一场热身赛中，国足与对手鏖战至最后时刻，凭借终场前的一粒进球惊险取胜，比赛过程跌宕起伏。" },
      { type: "h2", text: "年轻人获得更多锻炼机会" },
      { type: "p", text: "本场比赛，多名年轻球员获得出场时间，其中几人在攻防两端均有亮眼表现，展现出不错的潜力。" },
      { type: "p", text: "教练组赛后表示，球队仍在磨合阶段，会继续给年轻球员机会，通过比赛积累经验。" },
    ],
  },
  {
    id: "1015",
    title: "全运会开幕在即，众多新星值得期待",
    summary:
      "新一届全运会即将开幕，多个项目涌现出大批年轻新星，他们将成为本届赛事最值得关注的看点之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20sports%20arena%20with%20running%20track%20and%20bright%20overhead%20lights%2C%20athletes%20in%20motion%20blur%2C%20energetic%20atmosphere%2C%20editorial%20sports%20photography%2C%20vivid%20colors&width=800&height=500&seq=news-cover-91-15&orientation=landscape",
    category: "体育",
    subCategory: "综合",
    author: "91爆料体育组",
    publishDate: "2026-10-07 13:00",
    views: 47800,
    likes: 2130,
    tags: ["综合", "全运会"],
    content: [
      { type: "p", text: "新一届全运会开幕在即，各代表团陆续抵达赛区进行适应性训练，赛事氛围日渐浓厚。" },
      { type: "h2", text: "新生代运动员集中亮相" },
      { type: "p", text: "本届赛事汇聚了大批年轻选手，他们在近年的国内外比赛中成绩亮眼，被视为各自的夺牌热门。" },
      { type: "p", text: "多位教练表示，全运会既是竞技舞台，也是年轻运动员积累大赛经验的重要机会。" },
    ],
  },
  {
    id: "1016",
    title: "深度爆料：某热门选秀节目背后资本博弈内幕",
    subtitle: "从选人到成团，一场关于流量与话语权的角力",
    summary:
      "经过多方走访，本网梳理出一档热门选秀节目背后的资本博弈脉络，从选手签约到成团名额，玄机远比镜头呈现的复杂。",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20abstract%20spotlight%20over%20a%20dark%20stage%20with%20scattered%20paper%20documents%2C%20dramatic%20shadows%2C%20investigative%20journalism%20concept%2C%20cinematic%20editorial%20photography%2C%20orange%20highlights&width=800&height=500&seq=news-cover-91-16&orientation=landscape",
    category: "娱乐",
    subCategory: "综艺",
    author: "91爆料调查组",
    publishDate: "2026-10-16 04:00",
    views: 187300,
    likes: 15320,
    tags: ["独家", "爆料", "综艺"],
    hot: true,
    content: [
      { type: "p", text: "过去两个月，本网调查组围绕一档热门选秀节目展开了持续的走访与核实。从选手签约、镜头分配，到最终的成团名额，一条若隐若现的利益链条逐渐浮出水面。" },
      { type: "h2", text: "镜头背后的「隐形剧本」" },
      { type: "p", text: "多位参与节目录制的受访者表示，部分选手的曝光节奏并非完全由现场表现决定。剪辑侧重、故事线铺设等环节，都可能受到外部因素影响。" },
      { type: "img", src: "https://readdy.ai/api/search-image?query=Backstage%20of%20a%20television%20production%20with%20monitors%20and%20cables%2C%20dim%20lighting%20and%20mysterious%20mood%2C%20documentary%20editorial%20photography%2C%20cinematic%20shadows&width=900&height=560&seq=news-inside-91-16a&orientation=landscape", caption: "节目录制后台（应受访者要求，图片为示意）" },
      { type: "quote", text: "「有些结果，在镜头开拍之前其实就已经有了倾向。」——一位不愿具名的业内从业者说。" },
      { type: "h2", text: "资本、平台与艺人的三方角力" },
      { type: "p", text: "调查显示，围绕节目形成的利益格局大致涉及资本方、平台方与艺人经纪公司三方。成团名额的分配，往往需要在多方诉求之间寻求平衡。" },
      { type: "p", text: "截至发稿，节目方尚未就相关问题作出公开回应。本网将持续关注事态进展。" },
    ],
  },
];